import React from 'react';

import Table from 'components/clarity-ui/components/table/table';
import TableHeader from 'components/clarity-ui/components/table/tableHeader';
import TableRow from 'components/clarity-ui/components/table/tableRow';
import TableData from 'components/clarity-ui/components/table/tableData';
import { Link } from 'react-router';

class LabelParentsTableComponent extends React.Component {

  renderTableRows () {
    const tableRows = this.props.parentLabels.map((item) => {
      const { id, name } = item;
      return (
        <TableRow key={id}>
          <TableData>{id}</TableData>
          <TableData><Link to={`/labelViewer/${id}`}>{name}</Link></TableData>
        </TableRow>
      );
    });

    return tableRows;
  }

  render () {
    return (
      <Table>
        <tbody>
          <TableRow isHeader>
            <TableHeader>Id</TableHeader>
            <TableHeader>Name</TableHeader>
          </TableRow>
          { this.renderTableRows() }
        </tbody>
      </Table>
    );
  }
}

export default LabelParentsTableComponent;



// WEBPACK FOOTER //
// ./src/components/labelViewer/details/labelParentsTable.component.jsx